import { Model } from '@models/model';
import { Paginated } from '../paginated';

export class Categorie extends Model {
  idCategory: string;
  shortDescription: string;
  numTemplates: number;
  isBasic: boolean;
}

export class Template extends Model {
  idTemplate: number;
  name: string;
  bodyText: string;
  bodyHtml: string;
  inlineHtml: string;
  categories: [];
  description: string;
  thumbnailUrl: string;
  isBasic: boolean;
  isFree: boolean;
  isNew: boolean;
  idUser: number;
  descriptionLabel: string;
  isMobile: boolean;
  isDesktop: boolean;
}

export class Templates extends Paginated {
  data: Array<Template>;
}

export class TemplateCreateHtml extends Model {
  name: string;
  bodyHtml: string;
  bodyText?: string;
  dataType?: string;
  inlineHtml?: string;
}

export class TemplateCreateFile extends Model {
  name: string;
  file: string;
}
